'use client';

import type { ComponentProps, ReactElement } from 'react';
import { cva } from 'class-variance-authority';
import { NavigationMenu as NavigationMenuPrimitive } from 'radix-ui';

import { cn } from '../utils/tw-merge.util';

const navigationMenuLinkVariants = cva('text-base font-semibold text-charcoal-800 hover:underline dark:text-white');

export function NavigationMenuRoot({
  className,
  ...props
}: ComponentProps<typeof NavigationMenuPrimitive.Root>): ReactElement {
  return (
    <NavigationMenuPrimitive.Root
      data-slot="navigation-menu"
      className={cn('relative flex items-center', className)}
      {...props}
    />
  );
}

export function NavigationMenuList({
  className,
  ...props
}: ComponentProps<typeof NavigationMenuPrimitive.List>): ReactElement {
  return (
    <NavigationMenuPrimitive.List
      data-slot="navigation-menu-list"
      className={cn('flex list-none items-center gap-2', className)}
      {...props}
    />
  );
}

export function NavigationMenuItem({
  className,
  ...props
}: ComponentProps<typeof NavigationMenuPrimitive.Item>): ReactElement {
  return <NavigationMenuPrimitive.Item data-slot="navigation-menu-item" className={className} {...props} />;
}

export function NavigationMenuLink({
  className,
  ...props
}: ComponentProps<typeof NavigationMenuPrimitive.Link>): ReactElement {
  return (
    <NavigationMenuPrimitive.Link
      data-slot="navigation-menu-link"
      className={cn(navigationMenuLinkVariants(), className)}
      {...props}
    />
  );
}
